import type { ParsedAddress } from '../components/ui/QuickPasteAddress'

/**
 * Calls the server-side AI address parser (Claude Haiku via the elBooks Go server).
 * Only invoked when the rule-based parser can't extract city or postalCode.
 */
export async function parseAddressWithAI(
  text: string,
  includeGSTIN: boolean,
): Promise<ParsedAddress> {
  const res = await fetch('/api/v1/ai/parse-address', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ text, includeGstin: includeGSTIN }),
  })

  if (!res.ok) {
    throw new Error(`AI parse failed: ${res.status}`)
  }

  return res.json() as Promise<ParsedAddress>
}
